import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { GestureConfig } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import {ErrorHandler, NgModule} from '@angular/core';
import { GirkoComponent } from './girko.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import {GirkoRouterModule} from './girko.router.module';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {StoreModule} from '@ngrx/store';
import {reducers} from './store';
import {EffectsModule} from '@ngrx/effects';
import {metaReducers} from './store/meta-reducers';
import {AppContextEffect} from './effects/AppContextEffects';
import {ServiceEffects} from './effects/ServiceEffects';
import {AuthHttpService} from './services/auth-http.service';
import {LoginComponent} from './login/login.component';
import * as Raven from 'raven-js';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HeaderConnectedComponent} from './header/header-connected.component';
import {environment} from '../environments/environment';
import {RouterStateSerializer, StoreRouterConnectingModule} from '@ngrx/router-store';
import {CustomRouterStateSerializer} from './store/router/router-state-serializer';
import {ShowHeaderEffects} from './effects/ShowHeaderEffects';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { GirkoCommonModule } from './common/girko-common.module';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';


let dev: any[] = [];
if (environment.production) {
  Raven.config('https://85ecaac9b1b4418b931493d45e531c49@sentry.io/1219137', {
    release: environment.version,
  }).install();
} else {
  dev = [StoreDevtoolsModule.instrument({
    maxAge: 25,
  })];
}

export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    if (environment.production) {
      Raven.captureException(err);
    } else {
      console.error(err);
    }
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    GirkoComponent,
    HeaderConnectedComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    GirkoRouterModule,
    MatSidenavModule,
    MatListModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router',
    }),
    EffectsModule.forRoot([AppContextEffect, ServiceEffects, ShowHeaderEffects]),
    ...dev,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
    GirkoCommonModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: RavenErrorHandler },
    AuthHttpService,
    { provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
  ],
  bootstrap: [GirkoComponent],
})
export class GirkoModule {}
